import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../shared/services/api.service';
import { JhiLanguageService } from 'ng-jhipster';

class NavTab {
  title: string;
  active: boolean;
  disabled: boolean;
  iconClass: string;
}

@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styles: []
})
export class LogsComponent implements OnInit {

  loadingIndicator: boolean;
  navTabs: NavTab[] = [
    {
      title: 'SMS-Logs',
      active: false,
      disabled: false,
      iconClass: 'fa-commenting'
    },
    {
      title: 'E-Mail-Logs',
      active: false,
      disabled: false,
      iconClass: 'fa-envelope'
    }
  ];

  constructor(private jhiLanguageService: JhiLanguageService, private apiService: ApiService) {
    this.loadingIndicator = true;
    this.jhiLanguageService.setLocations(['logs']);
  }

  ngOnInit(): void {
  }

  selectNavTab(selectedNavTab: NavTab) {
    if (!selectedNavTab) {
      this.navTabs.forEach(navTab => navTab.active = false);
    } else if (!selectedNavTab.disabled) {
      this.navTabs.forEach(navTab => navTab.active = false);
      this.navTabs.find(navTab => navTab === selectedNavTab).active = true;
    }
  }

  getActiveNavTab(): NavTab {
    return this.navTabs.find(navTab => navTab.active)
      || { title: null, active: true, disabled: false, iconClass: null };
  }

}



// WEBPACK FOOTER //
// ./src/app/logs/components/logs/logs.component.ts